import React from "react";
import { Warehouse } from "../../types/Warehouse";
import Button from "../ui/Button";

interface WarehouseItemProps {
  warehouse: Warehouse;
  onEdit: () => void;
  onDelete: () => void;
}

const WarehouseItem: React.FC<WarehouseItemProps> = ({
  warehouse,
  onEdit,
  onDelete,
}) => {
  const getLocationsBadge = (hasWarehouseLocations: boolean) => {
    if (hasWarehouseLocations) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
          Attivate
        </span>
      );
    } else {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800">
          Disattivate
        </span>
      );
    }
  };

  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm font-medium text-gray-900">
          {warehouse.name}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-500">{warehouse.externalId}</div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-500">
          {warehouse.notificationEmail || "-"}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        {getLocationsBadge(warehouse.hasWarehouseLocations)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <Button variant="secondary" size="sm" onClick={onEdit} className="mr-2">
          Modifica
        </Button>
        <Button variant="danger" size="sm" onClick={onDelete}>
          Elimina
        </Button>
      </td>
    </tr>
  );
};

export default WarehouseItem;
